import { selfAxios } from "../../../../axios/selfAxios.js";
async function reqProductRelation(params) {
  const {
    data: { data }
  } = await selfAxios.post("/mtdsretail/linkage/productRelation", params, { _cache: true });
  return data;
}
export { reqProductRelation };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/mtdsretail/linkage/productRelation/post.js